import Head from "next/head";

const SportsEventSchema = ({ venue = "", startDate = "", title = "", description = "" }) => {
 
  return (
    <Head>
      <script
        id="ItemListSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SportsEvent",
            name: title,
            description: description,
            startDate: startDate,
            location: {
                "@type": "Place",
                name: venue, 
            }
          }),
        }}
      />
    </Head>
  );
};

export default SportsEventSchema;
